import { render, staticRenderFns } from "./BasicEduSuccessCases.vue?vue&type=template&id=c00bd22e"
import script from "./BasicEduSuccessCases.vue?vue&type=script&lang=js"
export * from "./BasicEduSuccessCases.vue?vue&type=script&lang=js"
import style0 from "./BasicEduSuccessCases.vue?vue&type=style&index=0&id=c00bd22e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports